import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// MSAL Configuration for Microsoft Entra ID
const msalConfig = {
  auth: {
    clientId: window.ENV.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${window.ENV.AZURE_TENANT_ID}`,
    redirectUri: window.ENV.REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
  },
};

// console.log("=== MSAL Configuration ===");
// console.log("clientId:", window.ENV.REACT_APP_AZURE_CLIENT_ID);
// console.log("tenantId:", window.ENV.REACT_APP_AZURE_TENANT_ID);
// console.log(
//   "redirectUri:",
//   window.ENV.REACT_APP_REDIRECT_URI || window.location.origin,
// );

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// console.log("=== Initializing MSAL ===");

// Initialize MSAL and handle redirect callback
msalInstance
  .initialize()
  .then(() => {
    // console.log("MSAL initialized successfully");

    // Handle redirect promise - THIS IS CRITICAL
    msalInstance
      .handleRedirectPromise()
      .then((response) => {
        // console.log("=== handleRedirectPromise resolved ===");
        // console.log("Response:", response);

        if (response) {
          // console.log("Authentication response received!");
          // console.log("Account:", response.account);
          // console.log(
          //   "Access Token:",
          //   response.accessToken ? "Present" : "Missing",
          // );
          // console.log("ID Token:", response.idToken ? "Present" : "Missing");
          // console.log("Username:", response.account?.username);
          // console.log("Name:", response.account?.name);

          // Set the active account
          msalInstance.setActiveAccount(response.account);
          // console.log("Active account set:", response.account.username);
        } else {
          // console.log("No authentication response (normal page load)");

          // Check if there are any accounts in cache
          const accounts = msalInstance.getAllAccounts();
          // console.log("Cached accounts:", accounts);

          if (accounts.length > 0) {
            // console.log(
            //   "Setting active account from cache:",
            //   accounts[0].username,
            // );
            msalInstance.setActiveAccount(accounts[0]);
          } else {
            // console.log("No cached accounts found");
          }
        }

        // Render the app after handling auth
        renderApp();
      })
      .catch((error) => {
        console.error("=== handleRedirectPromise error ===");
        console.error("Error:", error);
        console.error("Error name:", error.name);
        console.error("Error message:", error.message);

        // Still render the app even if there's an error
        renderApp();
      });

    // Add event callbacks for debugging
    msalInstance.addEventCallback((event) => {
      // console.log("=== MSAL Event ===");
      // console.log("Event type:", event.eventType);
      // console.log("Event payload:", event.payload);

      if (event.eventType === EventType.LOGIN_SUCCESS) {
        // console.log("LOGIN_SUCCESS event detected");
        // console.log("Account:", event.payload.account);
        msalInstance.setActiveAccount(event.payload.account);
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error("LOGIN_FAILURE event detected");
        console.error("Error:", event.payload);
      }

      if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
        // console.log("ACQUIRE_TOKEN_SUCCESS event detected");
      }

      if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        console.error("ACQUIRE_TOKEN_FAILURE event detected");
        console.error("Error:", event.payload);
      }
    });
  })
  .catch((error) => {
    console.error("=== MSAL initialization error ===");
    console.error("Error:", error);
  });

// Create React Query client for data caching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function renderApp() {
  // console.log("=== Rendering React app ===");

  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </MsalProvider>
      </HelmetProvider>
    </React.StrictMode>,
  );

  // console.log("React app rendered");
}

reportWebVitals();
